export default __webpack_public_path__ + "abc5b992941ee234325731e7ed274f8c.jpg";